import {ChangeDetectionStrategy, Component, Signal, viewChild} from "@angular/core";
import {navParam} from "../../navigation/navigation-params";
import {Page} from "../../navigation/page";
import {FormComponent} from '../../inputs/form/form.component';
import {TextFieldComponent} from '../../inputs/text-field/text-field.component';
import {ModalPageLayoutComponent} from '../../page-layout/modal-page-layout/modal-page-layout.component';
import {FormsModule} from '@angular/forms';
import {ButtonComponent} from '../../buttons/button/button.component';
import {PageFooterControlDirective} from '../../page-layout/page-footer-control.directive';

@Component({
    selector: "woa-name-edit-page",
    templateUrl: "./name-edit-page.component.html",
    styleUrl: "./name-edit-page.component.scss",
    providers: [{provide: Page, useExisting: NameEditPageComponent}],
    imports: [
        ButtonComponent,
        FormComponent,
        FormsModule,
        ModalPageLayoutComponent,
        PageFooterControlDirective,
        TextFieldComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NameEditPageComponent extends Page {
    public readonly form: Signal<FormComponent> = viewChild.required(FormComponent);

    public readonly transferTargetName: Signal<string> = navParam<string>("transferTargetName");

    public name: string;

    async confirmName(): Promise<void> {
        if (!this.form().valid) {
            return;
        }
        void this.dismiss(this.name);
    }
}
